import { ErrorBaseData } from '.'

export const patientErrors: Record<string, ErrorBaseData> = {
  PatientAlreadyExistsException: {
    message: 'Paciente já cadastrado',
    description: 'Esse paciente já foi cadastrado anteriormente',
  },
  PatientNotFoundException: {
    message: 'Paciente não encontrado',
    description: 'Não foi possível encontrar o paciente. Verifique as informações e tente novamente',
  },
}
